export default __webpack_public_path__ + "static/media/bg-talk-2a.9cd15470.png";